export default [
  {
    url: '/',
    name: '个人中心',
    icon: 'HomeIcon',
  },
  {
    url: null,
    name: '赛事评审',
    slug: 'myMatch',
    icon: 'ListIcon',
    submenu: [
      {
        url: '/match/list',
        name: '列表',
        slug: '',
      }
    ]
  },
  {
    url: '/user/profile',
    name: '个人信息',
    icon: 'UserIcon',
    slug: ''
  },
  {
    header: '其他'
  },
]